import { ReactElement } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { PAGE_ICONS } from '../../_const';
import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

/**
 * Display information about the form before submission
 * @param {string|ReactElement} summary overview of what will happen upon submission
 * @param {object[]} details list of `key`-`value` string pairs that will be displayed
 * @returns {ReactElement} component displaying information about the errors or the submission details
 */
const ReviewAndSubmit = ({ summary, details }) => {
	return (
		<Card variant='outlined' sx={{ minHeight: 150, m: 1, flexGrow: 1 }}>
			<CardContent>
				<Stack direction='column' gap={1}>
					<Stack direction='row' alignItems='center' gap={1}>
						<PAGE_ICONS.IDENTITY color='secondary' />
						<Typography variant='h5' component='div'>
							Review and Submit
						</Typography>
					</Stack>

					<Typography variant='body2'>
						{summary}
						<ul>
							{details.map(({ key, value }) => (
								<li key={nanoid()}>
									{key}: {value}
								</li>
							))}
						</ul>
					</Typography>
				</Stack>
			</CardContent>
		</Card>
	);
};

ReviewAndSubmit.propTypes = {
	summary: PropTypes.string.isRequired,
	details: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
		})
	),
};

export default ReviewAndSubmit;
